import { useEffect } from 'react';

import style from './addExtensionCta.module.css'
import consts from './consts';
import utils from './utils';
import AnimatedArrow from './animatedArrow'

import { useStateValue } from '../state';
import config from './config';

export default function AddExtensionCta() {
   const [
    {user},
    dispatch,
  ] = useStateValue()

  useEffect(() => {
    utils.trackPageView('AddExtensionCta');
  },[])

   function getTitleText(version) {
    if(version === 0) {
      return <span>What If You Could Send Files <br/> From Everywhere, Anytime?</span>
    } else if (version === 1) {
      return <span>Get Transfer Superpowers.<br/> Send Files From Everywhere.</span>
    }
   }

   function renderExtensionIcon() {
     return (
      <svg className={style.extensionIcon} xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path d="M2.72571 7.11378H6.50245C6.83634 7.11378 7.15655 6.98115 7.39264 6.74505C7.62873 6.50896 7.76137 6.18875 7.76137 5.85487V4.59595C7.76137 3.92818 8.02664 3.28776 8.49882 2.81558C8.97101 2.3434 9.61143 2.07813 10.2792 2.07812C10.947 2.07813 11.5874 2.3434 12.0596 2.81558C12.5318 3.28776 12.797 3.92818 12.797 4.59595V5.85487C12.797 6.18875 12.9297 6.50896 13.1658 6.74505C13.4018 6.98115 13.7221 7.11378 14.0559 7.11378H17.8327C18.1666 7.11378 18.4868 7.24642 18.7229 7.48251C18.959 7.7186 19.0916 8.03881 19.0916 8.3727V12.1494C19.0916 12.4833 19.2242 12.8035 19.4603 13.0396C19.6964 13.2757 20.0166 13.4084 20.3505 13.4084H21.6094C22.2772 13.4084 22.9176 13.6736 23.3898 14.1458C23.862 14.618 24.1273 15.2584 24.1273 15.9262C24.1273 16.594 23.862 17.2344 23.3898 17.7066C22.9176 18.1787 22.2772 18.444 21.6094 18.444H20.3505C20.0166 18.444 19.6964 18.5766 19.4603 18.8127C19.2242 19.0488 19.0916 19.369 19.0916 19.7029V23.4797C19.0916 23.8136 18.959 24.1338 18.7229 24.3699C18.4868 24.6059 18.1666 24.7386 17.8327 24.7386H14.0559C13.7221 24.7386 13.4018 24.6059 13.1658 24.3699C12.9297 24.1338 12.797 23.8136 12.797 23.4797V22.2208C12.797 21.553 12.5318 20.9126 12.0596 20.4404C11.5874 19.9682 10.947 19.7029 10.2792 19.7029C9.61143 19.7029 8.97101 19.9682 8.49882 20.4404C8.02664 20.9126 7.76137 21.553 7.76137 22.2208V23.4797C7.76137 23.8136 7.62873 24.1338 7.39264 24.3699C7.15655 24.6059 6.83634 24.7386 6.50245 24.7386H2.72571C2.39183 24.7386 2.07162 24.6059 1.83552 24.3699C1.59943 24.1338 1.4668 23.8136 1.4668 23.4797V19.7029C1.4668 19.369 1.59943 19.0488 1.83552 18.8127C2.07162 18.5766 2.39183 18.444 2.72571 18.444H3.98463C4.6524 18.444 5.29281 18.1787 5.765 17.7066C6.23718 17.2344 6.50245 16.594 6.50245 15.9262C6.50245 15.2584 6.23718 14.618 5.765 14.1458C5.29281 13.6736 4.6524 13.4084 3.98463 13.4084H2.72571C2.39183 13.4084 2.07162 13.2757 1.83552 13.0396C1.59943 12.8035 1.4668 12.4833 1.4668 12.1494V8.3727C1.4668 8.03881 1.59943 7.7186 1.83552 7.48251C2.07162 7.24642 2.39183 7.11378 2.72571 7.11378Z" stroke="white" strokeWidth="2.34671" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
     );
   }

   function renderButtonText() {
     return (
       <div className={style.buttonTextWrapper}>
          {renderExtensionIcon()}
           <span className={style.buttonText}>
            Add to Chrome
          </span>
       </div>

     )
   }

   function onCtaClick() {
     utils.setLocalStorageItem(consts.LOCAL_STORAGE_KEYS.CLICKED_ON_INSTALL_EXTENSION_CTA, 365);
     utils.trackEvent(consts.TRACKING_CATEGORY.EXTENSION, 'onboarding_cta_click', 'install');
     dispatch({ type: 'USER-CHANGED', payload: {...user, isExtensionInstalled: true}});

   }

    return (
        <div className={style.addBrandCtaContent}>
        <a target="_blank" rel="noopener noreferrer"  href={config.EXTENSION_INSTALL_URL} className={style.brandPreviewImage} onClick={onCtaClick} style={{textDecoration: 'none'}}>
        <img src={'/images/chromeExtension.png'}/>
        </a>
         <div className={style.addBrandCtaRight}>
         <span className={style.addBrandCtaTextBold}>{getTitleText(1)}</span>
         <span className={style.addBrandCtaText}>Install FileDriver for chrome and get transfer superpowers. No matter if you are writing an email, searching google or visiting any other website. Send files from every tab in your browser with one click.</span>
         <div className={style.buttonContainer}>
         <a href={config.EXTENSION_INSTALL_URL} target="_blank" rel="noopener noreferrer" onClick={onCtaClick} style={{textDecoration: 'none'}} className={style.addBrandButton}>{renderButtonText()}</a>
         <AnimatedArrow arrowStyle={{top: '291px', left: '257px'}}/>
         </div>
       </div>
        </div>
    )
  }